import React, { useState } from 'react';
import { SkeletonLoading } from '@saleshandy/design-system';
import { accessibleOnClick } from '../../../../../../../../../shared/utils/accessible-on-click';
import Select from '../../../../../../../../../shared/design-system/components/select';
import { Placement } from '../../../../../../../../../shared/design-system/components/overlay';
import { TaskFilterKey, TaskStatusKey } from '../utils/enums';
import { getTaskFilterArray, getTaskStatusArray } from '../utils/helper';

interface TasksTabHeaderProps {
  isLoading?: boolean;
  selectedStatus?: TaskStatusKey;
  onStatusChange?: (status: TaskStatusKey) => void;
  selectedFilter?: TaskFilterKey;
  onFilterChange?: (filter: TaskFilterKey) => void;
}

const TasksTabHeader: React.FC<TasksTabHeaderProps> = ({
  isLoading,
  selectedStatus: propSelectedStatus,
  onStatusChange,
  selectedFilter: propSelectedFilter,
  onFilterChange,
}) => {
  const [
    internalSelectedFilter,
    setInternalSelectedFilter,
  ] = useState<TaskFilterKey>(TaskFilterKey.All);

  const selectedFilter = propSelectedFilter ?? internalSelectedFilter;
  const [
    internalSelectedStatus,
    setInternalSelectedStatus,
  ] = useState<TaskStatusKey>(TaskStatusKey.All);

  const selectedStatus = propSelectedStatus ?? internalSelectedStatus;

  const filters = getTaskFilterArray();
  const statusOptions = getTaskStatusArray();

  const handleFilterChange = (filterKey: TaskFilterKey) => {
    if (onFilterChange) {
      onFilterChange(filterKey);
    } else {
      setInternalSelectedFilter(filterKey);
    }
  };

  const handleStatusChange = (
    options: Array<{ key: string; label: string }>,
  ) => {
    if (options && options.length > 0) {
      const newStatus = options[0].key as TaskStatusKey;
      if (onStatusChange) {
        onStatusChange(newStatus);
      } else {
        setInternalSelectedStatus(newStatus);
      }
    }
  };

  return (
    <div className="tasks-tab-header d-flex align-items-center justify-content-between">
      <div className="global-tab-style d-flex w-auto">
        {
          // isLoading ? (
          //   <SkeletonLoading width={200} height={32} />
          // ) : (
          filters?.map((filter) => (
            <div
              key={filter?.key}
              className="d-flex align-items-center"
              {...accessibleOnClick(() => handleFilterChange(filter?.key))}
            >
              <span
                className={`d-flex align-items-center semibold-1 status-filter-chip ${
                  selectedFilter === filter?.key
                    ? 'active blue-txt-11'
                    : 'gray-txt-11'
                }`}
              >
                {filter?.label}
              </span>
            </div>
          ))
          // )
        }
      </div>
      <div className="tasks-tab-header__status">
        {/* {isLoading ? (
          <SkeletonLoading width={180} height={32} />
        ) : ( */}
        <Select
          options={statusOptions}
          selectedOptionKey={selectedStatus}
          placeholder="Status"
          placement={Placement.Bottom}
          optionRenderer={(option) => <span>{option?.label}</span>}
          selectedOptionRenderer={([option]) => <span>{option?.label}</span>}
          onChange={handleStatusChange}
          className="status-select"
        />
        {/* )} */}
      </div>
    </div>
  );
};

export default TasksTabHeader;
